import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    ListItem,
    ListItemText,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DATA } from "./data";
import { Fragment } from "react";
import { Styled } from "./styles";

const GetStarted = () => {
    return (
        <Accordion disableGutters>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                sx={{ fontSize: "25px" }}
            >
                Get started
            </AccordionSummary>
            <AccordionDetails sx={{ marginLeft: "16px" }}>
                <Styled.OrderedList>
                    {DATA.map((section, index) => (
                        <Fragment key={index}>
                            <ListItem
                                disablePadding
                                sx={{ display: "list-item", marginBottom: "8px" }}
                            >
                                {section.title}
                            </ListItem>
                            {section.items.length > 0 ? (
                                <Styled.UnorderedList>
                                    {section.items.map((item, subIndex) => (
                                        <ListItem key={subIndex} disablePadding>
                                            <ListItemText primary={item} />
                                        </ListItem>
                                    ))}
                                </Styled.UnorderedList>
                            ) : null}
                        </Fragment>
                    ))}
                </Styled.OrderedList>
            </AccordionDetails>
        </Accordion>
    );
};

export default GetStarted;
